import { ComponentPropsWithoutRef, ReactNode } from 'react';
import { ButtonWrapper } from './styles';
import { Box } from '@/components/Box/Box';
import { Loader } from '@/components/Loader/Loader';

export type ButtonVariantType = 'primary' | 'secondary' | 'danger';

export interface ButtonType extends ComponentPropsWithoutRef<'button'> {
  children?: ReactNode;
  width?: number | string;
  size?: 'medium' | 'large';
  variant?: ButtonVariantType;
  isLoading?: boolean;
  mobileStretch?: boolean;
}

export const ButtonNew = ({
  children,
  isLoading,
  disabled,
  size = 'medium',
  type = 'button',
  variant,
  ...props
}: ButtonType) => {
  return (
    <ButtonWrapper disabled={disabled || isLoading} size={size} type={type} variant={variant} {...props}>
      {isLoading && (
        <Box position='absolute' left={0} right={0} bottom={0} top={0} zIndex={1}>
          <Loader width='100%' size={size} />
        </Box>
      )}

      <Box display='flex' alignItems='center'>
        {children}
      </Box>
    </ButtonWrapper>
  );
};
